import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import banner from "../Assets/Images/banner.png";
import Header2 from "../components/Header2";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Slider from "react-slick";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { FaUserCircle } from "react-icons/fa";
import DiscoverLeft from "../Assets/Images/discoverLeft.png";
import Prel from "../Assets/Images/prel.png";
import Ailogo from "../Assets/Images/Layer_1.png";
import PrelShape from "../Assets/Images/disRightShape.png";
import user from "../Assets/Images/wdas.png";
import DrJan from "../Assets/Images/jan.jpg";
import bannerSide from "../Assets/Images/banner_side_shape.png";
import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';
import Footer from "../components/Footer";
import { useContext, useRef } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { IoMdCloseCircle } from "react-icons/io";
import { IMAGE_URL } from "../API";


const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}><FaAngleLeft /></div>
  );
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}><FaAngleRight /></div>
  );
};

function Home() {
  const { showProfileModal, proceedToProfile, handleCloseModal, handleConsultationClick, CMS } = useContext(ProfileContext);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  const hasMultiReviews = CMS.review?.length > 1;
  console.log(hasMultiReviews)

  // var testimonial_setting = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   centerMode: true,
  //   centerPadding: "27%",
  //   nextArrow: <CustomNextArrow />,
  //   prevArrow: <CustomPrevArrow />,
  //   responsive: [
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         arrows: false,
  //         centerPadding: "2%",
  //       },
  //     },
  //   ],
  // };
  const testimonial_setting = {
    dots: hasMultiReviews,
    infinite: hasMultiReviews,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: hasMultiReviews,
    centerMode: hasMultiReviews,
    centerPadding: hasMultiReviews ? "27%" : "0px",
    nextArrow: hasMultiReviews ? <CustomNextArrow /> : null,
    prevArrow: hasMultiReviews ? <CustomPrevArrow /> : null,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          centerMode: hasMultiReviews,
          centerPadding: hasMultiReviews ? "2%" : "0px",
        },
      },
    ],
  };

  console.log(CMS.about)
  return (
    <>
      {/* Profile Completion Modal */}
      <Modal show={showProfileModal} onHide={handleCloseModal} centered className="comm_modal logout_modal">
        <Modal.Body className="p-0">
          <Modal.Header>
            <IoMdCloseCircle onClick={handleCloseModal} />
          </Modal.Header>
          <div className="comm_inner_body_modal">
            <h4>Please complete your profile first.</h4>
            <div className="modal_pair_btns">
              <button className='main-btn' onClick={proceedToProfile}>Proceed</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <section className="banner_sec_outer">
        <Header2 />
        <div className="banner_sec">
          <Row className="main_banner_row">
            <Col xl={6}>
              <div className="banner-content">
                <div className="hero_banner_top_ai">
                  <figure className="banner_img"><img src={Ailogo} alt="" className="img-fluid" /></figure>
                  <p>AI-Powered Tool Helps find you solution</p>
                </div>
                <h1>Your Confidential</h1>
                <h2>AI Health Companion</h2>
                <div className="banner_bottom_content">
                  <div>
                    <h6>AI chatbot - Pioneering confidential Interactive AI Avatars</h6>
                    <button className="main-btn" type="submit" onClick={handleConsultationClick}>Start consultation</button>
                  </div>
                  <p>Experience personalized healthcare with your own private and intelligent AI doctor. Get instant, confidential medical insights, symptom analysis, and wellness advice—all tailored to your needs.</p>
                </div>
              </div>
            </Col>
            <Col xl={6}>
              <figure className="banner_img"><img src={banner} alt="" className="img-fluid" /></figure>
            </Col>
          </Row>
        </div>
      </section>
      <section className="discover_sec comm_sec_padd">
        <figure className="banner_side_shape"><img src={bannerSide} alt="" className="img-fluid" /></figure>
        <Container>
          <div className="comm_sec_head">
            <h3 className="comm_sec_heading discover_sec_heading text-center">Discover Endless Possibilities with AI-companion</h3>
          </div>
          <div className="product_detail_tabs_outer">
            <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="product_detail_tabs" >
              <Tab eventKey="home" title="voice / text interaction">
                <Slider {...settings} className="discover_slider">
                  <div className="inner-discover-slider">
                    <Container>
                      <Row className="row-gap-3 discover-slider-row">
                        <Col lg={7} className="p-0">
                          <div className="discover_slider_left">
                            <figure className="discover_left_img"><img src={DiscoverLeft} alt="" className="img-fluid" /></figure>
                          </div>
                        </Col>
                        <Col lg={5} className="p-0">
                          <div className="discover_right_sec_outer">
                            <figure className="prel_img_shape"><img src={PrelShape} alt="" className="img-fluid" /></figure>
                            <div className="discover_right_sec">
                              <figure className="prel_img"><img src={Prel} alt="" className="img-fluid" /></figure>
                              <h6>preliminary assessments</h6>
                              <p>Available 24/7, your AI doctor ensures privacy, accuracy, and convenience, empowering you to take control of your health anytime, anywhere.</p>
                              <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>Start consultation</Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                  <div className="inner-discover-slider">
                    <Container>
                      <Row className="row-gap-3 discover-slider-row">
                        <Col lg={7} className="p-0">
                          <div className="discover_slider_left">
                            <figure className="discover_left_img"><img src={DiscoverLeft} alt="" className="img-fluid" /></figure>
                          </div>
                        </Col>
                        <Col lg={5} className="p-0">
                          <div className="discover_right_sec_outer">
                            <figure className="prel_img_shape"><img src={PrelShape} alt="" className="img-fluid" /></figure>
                            <div className="discover_right_sec">
                              <figure className="prel_img"><img src={Prel} alt="" className="img-fluid" /></figure>
                              <h6>preliminary assessments</h6>
                              <p>Available 24/7, your AI doctor ensures privacy, accuracy, and convenience, empowering you to take control of your health anytime, anywhere.</p>
                              <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>Start consultation</Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Slider>
              </Tab>
              <Tab eventKey="profile" title="preliminary assessments">
                <Slider {...settings} className="discover_slider">
                  <div className="inner-discover-slider">
                    <Container>
                      <Row className="row-gap-3 discover-slider-row">
                        <Col lg={7} className="p-0">
                          <div className="discover_slider_left">
                            <figure className="discover_left_img"><img src={DiscoverLeft} alt="" className="img-fluid" /></figure>
                          </div>
                        </Col>
                        <Col lg={5} className="p-0">
                          <div className="discover_right_sec_outer">
                            <figure className="prel_img_shape"><img src={PrelShape} alt="" className="img-fluid" /></figure>
                            <div className="discover_right_sec">
                              <figure className="prel_img"><img src={Prel} alt="" className="img-fluid" /></figure>
                              <h6>preliminary assessments</h6>
                              <p>Available 24/7, your AI doctor ensures privacy, accuracy, and convenience, empowering you to take control of your health anytime, anywhere.</p>
                              <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>Start consultation</Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                  <div className="inner-discover-slider">
                    <Container>
                      <Row className="row-gap-3 discover-slider-row">
                        <Col lg={7} className="p-0">
                          <div className="discover_slider_left">
                            <figure className="discover_left_img"><img src={DiscoverLeft} alt="" className="img-fluid" /></figure>
                          </div>
                        </Col>
                        <Col lg={5} className="p-0">
                          <div className="discover_right_sec_outer">
                            <figure className="prel_img_shape">
                              <img src={PrelShape} alt="" className="img-fluid" />
                            </figure>
                            <div className="discover_right_sec">
                              <figure className="prel_img"><img src={Prel} alt="" className="img-fluid" /></figure>
                              <h6>preliminary assessments</h6>
                              <p>Available 24/7, your AI doctor ensures privacy, accuracy, and convenience, empowering you to take control of your health anytime, anywhere.</p>
                              <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>Start consultation</Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Slider>
              </Tab>
              <Tab eventKey="contact" title="tests recommendations">
                <Slider {...settings} className="discover_slider">
                  <div className="inner-discover-slider">
                    <Container>
                      <Row className="row-gap-3 discover-slider-row">
                        <Col lg={7} className="p-0">
                          <div className="discover_slider_left">
                            <figure className="discover_left_img">
                              <img
                                src={DiscoverLeft}
                                alt=""
                                className="img-fluid"
                              />
                            </figure>
                          </div>
                        </Col>
                        <Col lg={5} className="p-0">
                          <div className="discover_right_sec_outer">
                            <figure className="prel_img_shape">
                              <img
                                src={PrelShape}
                                alt=""
                                className="img-fluid"
                              />
                            </figure>
                            <div className="discover_right_sec">
                              <figure className="prel_img">
                                <img src={Prel} alt="" className="img-fluid" />
                              </figure>
                              <h6>preliminary assessments</h6>
                              <p>
                                Available 24/7, your AI doctor ensures privacy,
                                accuracy, and convenience, empowering you to
                                take control of your health anytime, anywhere.
                              </p>
                              <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>
                                Start consultation
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                  <div className="inner-discover-slider">
                    <Container>
                      <Row className="row-gap-3 discover-slider-row">
                        <Col lg={7} className="p-0">
                          <div className="discover_slider_left">
                            <figure className="discover_left_img">
                              <img
                                src={DiscoverLeft}
                                alt=""
                                className="img-fluid"
                              />
                            </figure>
                          </div>
                        </Col>
                        <Col lg={5} className="p-0">
                          <div className="discover_right_sec_outer">
                            <figure className="prel_img_shape">
                              <img
                                src={PrelShape}
                                alt=""
                                className="img-fluid"
                              />
                            </figure>
                            <div className="discover_right_sec">
                              <figure className="prel_img">
                                <img src={Prel} alt="" className="img-fluid" />
                              </figure>
                              <h6>preliminary assessments</h6>
                              <p>
                                Available 24/7, your AI doctor ensures privacy,
                                accuracy, and convenience, empowering you to
                                take control of your health anytime, anywhere.
                              </p>
                              <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>
                                Start consultation
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Slider>
              </Tab>
            </Tabs>
          </div>
        </Container>
      </section>
      {/* our_key_features_sec start here  */}
      <section className="our_key_features_sec comm_sec_padd">
        <Container>
          <div className="comm_sec_head">
            <h3 className="comm_sec_heading text-center">our key features</h3>
          </div>
          <Row className="row-gap-3 our_key_feat_row">
            {(CMS.feature && CMS.feature.length > 0) ?
              CMS.feature.map((f) =>
                <Col xl={3} md={6}>
                  <div className="our_key_feat_col" dangerouslySetInnerHTML={{ __html: f.title }}>
                    {/* <p>Pellentesque vehicula dolor elit, quis dignissim </p> */}
                  </div>
                </Col>)
              :
              <>
                <Col xl={3} md={6} className="m-auto">
                  <div className="our_key_feat_col">
                    <h5>
                      online real-time <br /> consultation
                    </h5>
                    {/* <p>Pellentesque vehicula dolor elit, quis dignissim </p> */}
                  </div>
                </Col>
                <Col xl={3} md={6}>
                  <div className="our_key_feat_col">
                    <h5>
                      24*7 <br /> open platform
                    </h5>
                    {/* <p>Aliquam imperdiet msuada eleifend aenea</p> */}
                  </div>
                </Col>
                <Col xl={3} md={6}>
                  <div className="our_key_feat_col">
                    <h5>
                      Easily <br /> accessible to all
                    </h5>
                    {/* <p>Nullam rutrum aliquet dolor, vitae cursus</p> */}
                  </div>
                </Col>
                <Col xl={3} md={6}>
                  <div className="our_key_feat_col">
                    <h5>
                      AI-powered <br /> facilities
                    </h5>
                    {/* <p>Pellentesque pellentesque turpis..</p> */}
                  </div><br />
                </Col>
              </>
            }
          </Row>
        </Container>
      </section>
      {/* about_dr_jan start here  */}
      <section className="about_dr_jan common_rounded_sec comm_sec_padd">
        <Container>
          <Row className="row-gap-3 comm_align_center_row">
            {CMS &&
              <>
                <Col lg={6}>
                  <div className="comm_sec_head">
                    <h3 className="comm_sec_heading">{CMS.about.heading || 'About Dr. jan'}</h3>
                  </div>
                  <div className="comm_sec_discrp_outer">
                    <div
                      className="comm_sec_discrp"
                      dangerouslySetInnerHTML={{ __html: CMS.about.description }}
                    />
                  </div>
                  <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>Start consultation</Link>
                </Col>
                <Col lg={6}>
                  <figure className="DrJanImage">
                    <img
                      src={IMAGE_URL + CMS.about.image}
                      alt="" className="img-fluid"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = DrJan;
                      }} />
                  </figure>
                </Col>
              </>
            }
          </Row>
        </Container>
      </section>

      {/* about_dr_jan start here  */}
      <section className="about_dr_jan comm_sec_padd">
        <Container>
          <div className="comm_sec_head what_customer_heading">
            <h3 className="comm_sec_heading text-center" >What our customer says about us</h3>
            {/* <p className="comm_sec_sub_heading text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum rhoncus magna sed augue pulvinar tempus. Suspendisse potenti. Praesent scelerisque.
            </p> */}
          </div>
        </Container>
        <Slider {...testimonial_setting} className="testimonial_slider">
          {(CMS.review && CMS.review.length > 0) ?
            CMS.review.map((r) =>
              <div className="item">
                <div className="testimonial_card">
                  <p className="testi_sec_discrip">{r.review}</p>
                  <div className="d-flex testi_user_detial_row">
                    <FaUserCircle size={42} color="#fff" />
                    <div className="testi_user_detial">
                      <h5 className="card-title">{r.author} </h5>
                      <p className="card-discrp">{r.address}</p>
                    </div>
                  </div>
                </div>
              </div>)
            :
            <>
              <div className="item">
                <div className="testimonial_card">
                  <p className="testi_sec_discrip">Suspendisse posuere malesuada purus, in pretium velit. Praesent vitae cursus ex. Vivamus vitae neque finibus, iaculis nisl et, interdum metus. Pellentesque imperdiet nisi a ex tincidunt, eget accumsan neque luctus. Nam aliquam eget massa id fringilla. Praesent quis quam suscipit, ultricies neque ut, congue ex.</p>

                  <div className="d-flex testi_user_detial_row">
                    <figure className="testi_user_image">
                      <img src={user} alt="" className="img-fluid" />
                    </figure>
                    <div className="testi_user_detial">
                      <h5 className="card-title">Mark Smith </h5>
                      <p className="card-discrp">London, UK</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="testimonial_card">
                  <p className="testi_sec_discrip">Suspendisse posuere malesuada purus, in pretium velit. Praesent vitae cursus ex. Vivamus vitae neque finibus, iaculis nisl et, interdum metus. Pellentesque imperdiet nisi a ex tincidunt, eget accumsan neque luctus. Nam aliquam eget massa id fringilla. Praesent quis quam suscipit, ultricies neque ut, congue ex.</p>
                  <div className="d-flex testi_user_detial_row">
                    <figure className="testi_user_image">
                      <img src={user} alt="" className="img-fluid" />
                    </figure>
                    <div className="testi_user_detial">
                      <h5 className="card-title">Mark Smith </h5>
                      <p className="card-discrp">London, UK</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="testimonial_card">
                  <p className="testi_sec_discrip">Suspendisse posuere malesuada purus, in pretium velit. Praesent vitae cursus ex. Vivamus vitae neque finibus, iaculis nisl et, interdum metus. Pellentesque imperdiet nisi a ex tincidunt, eget accumsan neque luctus. Nam aliquam eget massa id fringilla. Praesent quis quam suscipit, ultricies neque ut, congue ex.</p>
                  <div className="d-flex testi_user_detial_row">
                    <figure className="testi_user_image">
                      <img src={user} alt="" className="img-fluid" />
                    </figure>
                    <div className="testi_user_detial">
                      <h5 className="card-title">Mark Smith </h5>
                      <p className="card-discrp">London, UK</p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        </Slider>
      </section>

      {/* faq_sec start here  */}
      <section className="faq_sec common_rounded_sec comm_sec_padd">
        <Container>
          <Row className="row-gap-1">

            <Col lg={6} className="m-auto">
              <div className="comm_sec_head faq_sec_head">
                <h3 className="comm_sec_heading">Frequently asked questions</h3>
                {/* <p className="comm_sec_sub_heading">
                  Integer eleifend magna in ligula suscipit tristique. Morbi tempor consequat felis, eget sagittis augue auctor vel. Integer porttitor pellentesque gravida. Quisque ut nisl molestie, posuere justo ac, malesuada sapien. Vestibulum sagittis aliquam arcu ut euismod. In hac habitasse platea dictumst.
                </p> */}
              </div>

            </Col>
            <Col lg={6}>
              <section className="faq_sec">
                <Container>
                  <Accordion defaultActiveKey='0' className="accordion-flush">
                    {(CMS.faq && CMS.faq.length > 0) ?
                      CMS.faq.map((f, i) =>
                        <Accordion.Item eventKey={i}>
                          <Accordion.Header>{f.question}</Accordion.Header>
                          <Accordion.Body><p>{f.answer}</p></Accordion.Body>
                        </Accordion.Item>)
                      :
                      <>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            How it works?
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Lorem Ipsum It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            how can I get into it?
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Lorem Ipsum It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                          <Accordion.Header>
                            What features do you know?
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Lorem Ipsum It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                          <Accordion.Header>
                            What should I do to start consultation?
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Lorem Ipsum It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                          <Accordion.Header>
                            Is there any policies?
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Lorem Ipsum It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </>
                    }
                  </Accordion>
                </Container>
              </section>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Footer  */}
      <Footer />
    </>
  );
}
export default Home;
